export const URL = 'https://admin-quickdraft.sk.ua';
export const PAYLOAD_SECRET = '2623d7d099e2a59287e62ac3';
